<div class="component-wrapper">
  <div class="p15px">
    <div class="d-flex c-row">
      <!-- Sidebar -->
      <app-nav-users *ngIf="isHideSideNav"></app-nav-users>
      <!-- Main -->
      <div class="c-col w-100 c-main">
        <div class="c-main-body">
          <div class="body-details">
            <div class="d-flex align-items-center justify-content-between border-bottom pt-1 pb-3">
              <h3>Create New Role</h3>
            </div>
            <!-- Form -->
            <form [formGroup]="roleForm" (ngSubmit)="addRole()" class="form">
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="officename">Role Name</label>
                    <input
                      type="text"
                      class="site-input mt-1"
                      formControlName="name"
                      [ngClass]="{ '_input-error': submitted && roleForm.controls['name'].hasError('required') }" />
                    <span
                      class="dummy-text"
                      *ngIf="submitted && (roleForm.controls['name'].hasError('required') || roleForm.controls['name'].invalid)">
                      <span
                        class="form-error text-danger mt-1"
                        *ngIf="submitted && (roleForm.controls['name'].hasError('required') || roleForm.controls['name'].invalid)"
                        >Role name is required</span
                      >
                    </span>
                  </div>
                  <div class="form-group">
                    <label for="description">Description</label>
                    <textarea formControlName="description" class="site-input mt-1" cols="20" rows="3"></textarea>
                  </div>
                  <div class="form-group text-right mt-3" [style]="{ 'margin-bottom': '0px !important' }">
                    <button type="subumit" class="_outline-btn">
                      <span> Create Role</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
